import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class TipoVeiculoList extends Component {
    state = {
        searchFilter: loadStoredJson('tipoveiculoSearchFilter', {
            desctipoveiculo: '',
            situacaoInativoFilter: ANAO
        }),
        tiposveiculos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('tipoveiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('tipoveiculoRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;
        this.loadTiposVeiculo();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('tipoveiculoSearchFilter', searchFilter);
        }
        if (prevState.page !== page) {
            saveStoredValue('tipoveiculoPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('tipoveiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'tipoveiculoSearchFilter',
            'tipoveiculoPage',
            'tipoveiculoRowsPerPage'
        ]);
    };

    /* Carrega os tipos de veículo */
    loadTiposVeiculo = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { desctipoveiculo, situacaoInativoFilter } = searchFilter;

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: [
                {
                    field: 'DESCTIPOVEICULO',
                    value: desctipoveiculo,
                    operator: '_like_'
                },
                {
                    field: 'INATIVO',
                    value: situacaoInativoFilter
                }
            ]
        });

        try {
            const response = await api.get('/tipoveiculo' + params);

            this.safeSetState({
                tiposveiculos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar tipos de veículos:', error);

            this.safeSetState({
                tiposveiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadTiposVeiculo);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadTiposVeiculo);
    };

    /* Deleta o tipo de veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/tipoveiculo/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadTiposVeiculo();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir tipo de veículo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codtipoveiculo, desctipoveiculo) => {
        this.setState({
            open: true,
            selectedId: codtipoveiculo,
            selectedDesc: desctipoveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            desctipoveiculo: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadTiposVeiculo);
    };

    /* Pega a rota base - recurso compartilhado entre módulos */
    getBaseRoute = () => {
        const { location } = this.props;
        const pathname = location?.pathname || '';

        if (pathname.startsWith('/front/')) {
            return '/front/tipoveiculo';
        }

        return '/frotas/tipoveiculo';
    };

    render() {
        const {
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            tiposveiculos,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        const baseRoute = this.getBaseRoute();

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="desctipoveiculo"
                        name="desctipoveiculo"
                        onChange={this.onChangeSearch}
                        placeholder="Tipo"
                        value={searchFilter.desctipoveiculo}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadTiposVeiculo}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to={`${baseRoute}/novo`}
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {tiposveiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={3}
                                                >
                                                    Nenhum tipo de veículo encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {tiposveiculos.map(tipoveiculo => (
                                            <TableRow
                                                hover
                                                key={tipoveiculo.codtipoveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(tipoveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {tipoveiculo.codtipoveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(tipoveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {tipoveiculo.desctipoveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`${baseRoute}/${tipoveiculo.codtipoveiculo}`}>
                                                                <EditTwoTone
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`${baseRoute}/${tipoveiculo.codtipoveiculo}/view`}>
                                                                <VisibilityOutlined
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleOpen(
                                                                    tipoveiculo.codtipoveiculo,
                                                                    tipoveiculo.desctipoveiculo
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do tipo de veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default TipoVeiculoList;